import oldAPI from './api';
import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const oldapi = new oldAPI({ url: '/Home' });

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/user`,
  scopes: ExtHubRequest,
});
const apiPromos = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalPromos`,
  scopes: ExtHubRequest,
});
const apiProductToolkits = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalProductToolkit`,
  scopes: ExtHubRequest,
});
const apiEmergency = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalEmergencyNotes`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetClaimsDictionary' },
  { name: 'GetProducerClaim' },
  { name: 'GetUserAgencyID' },
  { name: 'GetUserInfo' },
  { name: 'GetClaimsList' },
]);

apiPromos.createEntities([{ name: 'GetPromos' }, { name: 'GetConvention' }]);

apiProductToolkits.createEntities([{ name: 'GetHomePageProductToolkits' }]);

apiEmergency.createEntities([{ name: 'getEmerNotesList' }]);

oldapi.createEntities([{ name: 'GetUrl' }]);

const GetPromos = () => apiPromos.endpoints.GetPromos.post();
const GetHomePageProductToolkits = (body) =>
  apiProductToolkits.endpoints.GetHomePageProductToolkits.post(body);
const GetClaimsList = (body) => api.endpoints.GetClaimsList.post(body);
const GetConvention = () => apiPromos.endpoints.GetConvention.post();
const GetProducerClaim = () => api.endpoints.GetProducerClaim.post();
const GetUserAgencyID = () => api.endpoints.GetUserAgencyID.post();
const GetUserInfo = () => api.endpoints.GetUserInfo.post();
const GetClaimsDictionary = (body) => api.endpoints.GetClaimsDictionary.post(body);
const GetUrl = () => oldapi.endpoints.GetUrl.postAsync();
const GetEmerNotesList = () => apiEmergency.endpoints.getEmerNotesList.post();

export {
  GetClaimsList,
  GetClaimsDictionary,
  GetConvention,
  GetProducerClaim,
  GetUserAgencyID,
  GetUserInfo,
  GetPromos,
  GetHomePageProductToolkits,
  GetUrl,
  GetEmerNotesList,
};
